import React, { FC, useState } from 'react';
import s from './PromptBlock.module.css';
import Button from '../../../../shared/ui/button/Button';
import { useAppDispatch } from '../../../../store/store';
import { setAddedHashtag } from '../../../../store/slices/pageSlice';

const HashtagsBlock: FC = () => {
    const dispatch = useAppDispatch();
    const hashtags = [
        { tag: '#wanderlust', usage: 15 },
        { tag: '#foodie', usage: 8 },
        { tag: '#inspiration', usage: 12 },
        { tag: '#mindfulness', usage: 7 },
        { tag: '#creativity', usage: 20 },
        { tag: '#adventure', usage: 11 },
        { tag: '#wellness', usage: 9 },
        { tag: '#motivation', usage: 16 },
        { tag: '#lifestyle', usage: 13 },
        { tag: '#photography', usage: 10 },
    ];

    const [hoveredTag, setHoveredTag] = useState<string | null>(null);
    const handleAddHashtag = (tag: string) => {
        dispatch(setAddedHashtag(tag));
    };
    return (
        <div className={s.container}>
            <div className={s.block_container}>
                <h3 className={s.bold_header}>Discover related trending hashtags</h3>
                <input type="text" placeholder="Search for hashtags" className={s.input} />
                {hashtags.map((item) => (
                    <div
                        key={item.tag}
                        className={s.hashtag_container}
                        onMouseEnter={() => setHoveredTag(item.tag)}
                        onMouseLeave={() => setHoveredTag(null)}
                    >
                        <span className={s.hashtag_text}>{item.tag}</span>
                        {hoveredTag !== item.tag && (
                            <span className={s.usage_count}>{item.usage}K posts</span>
                        )}
                        {hoveredTag === item.tag && (
                            <Button
                                onClick={() => handleAddHashtag(item.tag)}
                                text={'Add'}
                                style={{
                                    background: '#FFDD35',
                                    width: 'auto',
                                    fontSize: '10px',
                                    borderRadius: '5px',
                                    height: '25px',
                                }}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HashtagsBlock;
